module.exports = __webpack_public_path__ + "img/ic-list-address.966f488c.svg";